import $ from 'jquery';

function mediaTabsAccessibility() {
  if (typeof document === 'undefined') return;

  const tabsContainerSelector = '.c-mediaTabs__tabs';

  const normalizeTabIndexes = root => {
    const scope = root && root.querySelectorAll ? root : document;
    const links = scope.querySelectorAll(`${tabsContainerSelector} .tabs-title > a`);

    for (let i = 0; i < links.length; i++) {
      links[i].setAttribute('tabindex', '0');
    }
  };

  // Apply once after Foundation has initialized tab semantics.
  normalizeTabIndexes(document);

  // Re-apply whenever Foundation changes tab state.
  $(document).on('change.zf.tabs collapse.zf.tabs deeplink.zf.tabs', () => {
    normalizeTabIndexes(document);
  });
}

export default mediaTabsAccessibility;
